import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { ForwardButton } from '../../component/atom/Button';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { MARKETING_CHANNEL_OTHER_OPTION_TITLE } from '../../config/option';
import selectIndicatorImg from '../../asset/selectIndicator.svg';
const renderHeader = () => (<>
    <S.HeaderDialogBox>
      <S.HeaderDialog>
        您是從哪裡得知<span>Home心</span>的呢？
      </S.HeaderDialog>
      <S.HeaderImg src={selectIndicatorImg} alt='headerImg'/>
    </S.HeaderDialogBox>
    <S.HeaderNote>＊可複選</S.HeaderNote>
  </>);
const renderSelectionSection = ({ marketingChannelOptionList, selectedMarketingChannelList, otherChannel, isOtherChannelError, handleOptionChipClick, handleOtherChannelTextareaClick, handleOtherChannelTextareaChange, }) => (<S.LayoutOptionList>
    {marketingChannelOptionList.map((channel) => {
        const shouldRenderTextarea = channel === MARKETING_CHANNEL_OTHER_OPTION_TITLE &&
            selectedMarketingChannelList.includes(channel);
        const isOptionSelected = selectedMarketingChannelList.includes(channel);
        const isOptionError = channel === MARKETING_CHANNEL_OTHER_OPTION_TITLE && isOtherChannelError;
        const isOtherChannel = channel === MARKETING_CHANNEL_OTHER_OPTION_TITLE;
        return (<React.Fragment key={channel}>
          <S.OptionChip isSelected={isOptionSelected} isError={isOptionError} onClick={() => {
                handleOptionChipClick({ channel });
            }}>
            {channel}
            {shouldRenderTextarea ? (<S.OptionTextarea placeholder='請輸入管道' rows={5} maxLength={20} value={otherChannel} onClick={handleOtherChannelTextareaClick} onChange={handleOtherChannelTextareaChange}/>) : null}
          </S.OptionChip>
          <S.ErrorFeedbackText isShow={isOtherChannel && isOtherChannelError}>
            ＊此欄位必填
          </S.ErrorFeedbackText>
        </React.Fragment>);
    })}
  </S.LayoutOptionList>);
const renderForwardButton = ({ isForwardButtonAvailable, handleForwardButtonClick, }) => (<ForwardButton isAvailable={isForwardButtonAvailable} size={BUTTON_SIZE.MEDIUM} onButtonClick={handleForwardButtonClick}>
    確認
  </ForwardButton>);
export default function View({ 
// data
isLoading, marketingChannelOptionList, selectedMarketingChannelList, otherChannel, isOtherChannelError, isForwardButtonAvailable, 
// func
handleOptionChipClick, handleOtherChannelTextareaClick, handleOtherChannelTextareaChange, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const selectionSection = useMemo(() => renderSelectionSection({
        marketingChannelOptionList,
        selectedMarketingChannelList,
        otherChannel,
        isOtherChannelError,
        handleOptionChipClick,
        handleOtherChannelTextareaClick,
        handleOtherChannelTextareaChange,
    }), [
        marketingChannelOptionList,
        selectedMarketingChannelList,
        otherChannel,
        isOtherChannelError,
        handleOptionChipClick,
        handleOtherChannelTextareaClick,
        handleOtherChannelTextareaChange,
    ]);
    const forwardButton = useMemo(() => renderForwardButton({ isForwardButtonAvailable, handleForwardButtonClick }), [isForwardButtonAvailable, handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      <S.Layout>
        {header}
        {selectionSection}
        {forwardButton}
      </S.Layout>
    </RWDPageLayout>);
}
